import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-credit">
        Map and apps by Dianne Gray.  Website design originally created by John Paul Albana
      </div>
    </div>
  );
}

export default Footer;
